export default __webpack_public_path__ + "static/media/Avatar-14.2c338560.png";